import React, { Component } from 'react';
import ReactTextareaAutocomplete from '@webscopeio/react-textarea-autocomplete';
import { each } from 'lodash';

import {
    evaluateCalculation,
    QL,
} from '@swa_llow/pricing_engine';

function map_each ({ 
    inputs,
}) {
    let items = [];
    each(inputs, (v, k) => {
        items.push({
            name: k,
            char: `{{${k}}}`,
        });
    })
    return items;
}

export function evaluateCalculations({
    inputs,
    formula,
}) {
    const quote = {};

    each(inputs, (v, k) => {
        quote[k] = v.value;
    });

    const result = evaluateCalculation({ formula, original: QL(quote) });

    return {
        formula,
        invalid: result.invalid,
        message: result.message,
        result: result.result,
        elements: result.elements,
    };
}

class CalculationTextarea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputs: this.props.inputs,
            formatter : true,
        }
        this.updateInputValue = this.updateInputValue.bind(this);
        this.showFormatter = this.showFormatter.bind(this);
        this.format = this.format.bind(this);
    }

    showFormatter() {
        this.setState({
            formatter: !this.state.formatter,
        });
    }

    format(str = '') {
        let new_str = str.replace(/{{/g, '<span class="variable">');
        new_str = new_str.replace(/}}/g, '</span>');
        return new_str;
    }

    updateInputValue ({
        key, 
        value,
        type,
    }) {
        this.props.updateInputValue({
            [key] : {
                value,
                type,
            } 
        });
    }   

    render() {
        const inputs = map_each({ inputs: this.props.inputs });
        const { value } = this.props;
        const { formatter } = this.state;

        return (
            <div className="textarea-formatted-container">
                <ReactTextareaAutocomplete
                    value={value}
                    className="expression-textarea"
                    onFocus={this.showFormatter}
                    onBlur={this.showFormatter}
                    onChange={(e) => this.props.updateCalculation(e.target.value)}
                    loadingComponent={() => <span>Loading</span>}
                    trigger={{
                        "{{": {
                            dataProvider: token => {
                                return inputs.filter(item => item.char.includes(token));
                            },
                            component: ({ entity: { name, char } }) => (<div>{`${char}`}</div>),
                            output: (item) => item.char,
                        }
                    }}
                />
                {formatter && <div className="textarea-formatted-content" dangerouslySetInnerHTML={{__html: this.format(value)}}></div>}
            </div>
        );
    }
}

export default CalculationTextarea;